import { PageBlockLayout } from '../dashboard/paywall/sales-activated-trial/page/PageBlockLayout';
import { PAGEBLOCK_DATA_AGENTIC_LAYER } from '../../constants/pageblockData';
import { PageblockHeaderWithCta } from '../dashboard/paywall/sales-activated-trial/page/PageblockHeaderWithCta';

const AgentsNotAvailable = () => {
  const { imgSrc, imgAlt, name } = PAGEBLOCK_DATA_AGENTIC_LAYER.headerData;
  //headerText, subHeaderText and buttonText are specific to the case that no agent subscription exists

  return (
    <PageBlockLayout
      pageblockData={PAGEBLOCK_DATA_AGENTIC_LAYER}
      header={
        <PageblockHeaderWithCta
          headerText="Ask Your Metadata Anything"
          subHeaderText="Get instant answers from AI agents, from impact analysis to actionable insights. Automate processes, enforce data quality, and drive execution in one intelligent system."
          imgSrc={imgSrc}
          imgAlt={imgAlt}
          name={name}
          buttonText="Explore AI Agents"
        />
      }
    />
  );
};

export default AgentsNotAvailable;
